import api from '@/apis/di/inventoryItemAPI';
import Crud from '@/stores/crudBase.js';
var crud = new Crud('inventoryItem', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_inventory_item',
    field: {
      key: 'inventory_item_id',
      code: 'inventory_item_code',
      name: 'inventory_item_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
  setPaging(state, data) {
    if (data) {
      for (let i in data) {
        let resultValue = data[i];
        switch (i) {
          case 'PageData':
            state.items = resultValue;
            state.items.forEach(x => {
              x.closing_quantity = x.closing_quantity == 0 ? null : x.closing_quantity;
              x.closing_amount = x.closing_amount == 0 ? null : x.closing_amount;
              return x;
            });
            break;
          case 'Total':
            state.total = resultValue;
            break;
          case 'Empty':
            state.empty = resultValue;
            break;
          case 'SummaryData': {
            state.summary = resultValue;
            break;
          }
        }
      }
    }
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
